import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Mobile, TRANSITION_END, iOS, Android, Carousel_CoreInit } from './core'
import './modules/flavor-cards'
import './modules/product'

Carousel_CoreInit([
  {
    classSelector: 'carousel--style--default',
    swiperOptions: {
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
      },
    },
  },
])

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
    is_version: undefined,
    cards: undefined,
    scroller: $(window).ScrollEvents(),
    title_st: undefined,
  }

  /* Advanced scroll events */
  gsap.registerPlugin(ScrollTrigger)

  /* Refresh on toggle */
  $.mlmi.mobile.add(function() {
    if ($.mlmi.is_version == undefined) {
      $.mlmi.is_version = 'mobile';
    } else if ($.mlmi.is_version == 'desktop') {
      $(window).scrollTop(0)
      $('body').hide()
      location.reload()
    }
  }, function() {
    if ($.mlmi.is_version == undefined) {
      $.mlmi.is_version = 'desktop';
    } else if ($.mlmi.is_version == 'mobile') {
      $(window).scrollTop(0)
      $('body').hide()
      location.reload()
    }
  })

  /* Btn wrap */
  $('.btn-primary, .btn-secondary, .btn-black, .btn-down').wrapInner('<span></span>')

  /* Home page scroll */
  if ($('body').hasClass('front-page')) {
    /* Footer signature */
    let signatureFooter = $('.footer'),
    signatureVisible = false,
    signatureHeight = 0,
    headerHeight = 0,
    headerVisible = true,
    windowHeight = 0

    /* Calculate heights */
    function calculateHeight() {
      signatureHeight = $('.footer-signature').outerHeight(false)
      windowHeight = (Android() || iOS()) ? window.outerHeight : window.innerHeight
      $('html').css({
        '--signature-height': signatureHeight + 'px',
        '--vh100': windowHeight + 'px',
      })
    }
    $(window).on('load resize orientationchange', calculateHeight)
    calculateHeight()

    /* Basic scroll events */
    $.mlmi.scroller.add(function(top, direction) {
      let footerY = signatureFooter.offset().top - $(window).height()
      if (!signatureVisible && footerY <= top - signatureHeight) {
        $('.footer-signature').addClass('footer-signature--visible')
        $('.first-section').css({
          'opacity': 0,
          'pointer-events': 'none',
        })
        signatureVisible = true
      } else if (signatureVisible && footerY > top - signatureHeight) {
        $('.footer-signature').removeClass('footer-signature--visible')
        $('.first-section').css({
          'opacity': '',
          'pointer-events': '',
        })
        signatureVisible = false
      }
      if (!headerVisible && top > 1) {
        headerVisible = true
        $('.first-section').css({
          'opacity': '',
          'pointer-events': '',
        })
      } else if (headerVisible && top <= 1) {
        headerVisible = false
        $('.first-section').css({
          'opacity': 0,
          'pointer-events': 'none',
        })
      }
    })

    /* Terazzo */
    $('.terazzo path').each(function() {
      gsap.to($(this).get(0), {
        opacity: 1,
        duration: .333,
        delay: Math.max((1 * ($(this).offset().top / window.innerHeight).toFixed(2) + (Math.random() * .3 - .15)), 0),
      })
    })

    /* Title effect */
    $.mlmi.title_st = gsap.to('.header-brand', {
      scale: $.mlmi.mobile.isMobile ? .35 : .2,
      scrollTrigger: {
        trigger: '.terazzo',
        endTrigger: '#cards',
        start: '66.667% top',
        end: 'top top',
        scrub: true,
        invalidateOnRefresh: true,
      },
    })

    /* First row content */
    gsap.from('.first-row-content', {
      y: '+=30vh',
      scrollTrigger: {
        trigger: '.terazzo',
        endTrigger: '#cards',
        start: 'top top',
        end: 'top top',
        scrub: .666,
        invalidateOnRefresh: true,
      },
    })
    gsap.to('.first-row-content', {
      opacity: 0,
      scrollTrigger: {
        trigger: '#cards',
        endTrigger: '#cards',
        start: 'top 35%',
        end: 'top top',
        scrub: .666,
        invalidateOnRefresh: true,
      },
    })

    /* Footer spin effect */
    gsap.from('.footer__tripes-de-fou', {
      rotate: '-=250deg',
      scrollTrigger: {
        trigger: '.footer',
        start: 'top bottom',
        end: () => `bottom bottom-=${signatureHeight}`,
        scrub: .666,
        invalidateOnRefresh: true,
      },
    })

    /* Click on card */
    $('.flavors').each(function() {
      $.mlmi.cards = $(this).FlavorCards()
    })
  }

  if ($('body').hasClass('page-horizontale')) {
    let product = $('[data-id="poivre-blanc"]').Product()
    product.display()
    product.initialize_animations()
  }

  let refreshTimeout = undefined
  $(window).on('resize orientationchange', function() {
    if (!Android() && !iOS()) {
      clearTimeout(refreshTimeout)
      refreshTimeout = setTimeout(function() {
        ScrollTrigger.refresh()
      }, 450)
    }
  })

  let open_buffer = false
  $('a[href="#cards"]').on('click', function() {
    if ($(this).data('open')) {
      open_buffer = $(this).data('open')
    } else {
      open_buffer = false
    }
    $('html, body').scrollTo($('#cards').offset().top, 350, 2, 'easeInOutQuart', function() {
      if (open_buffer) {
        $('a[href="#' + open_buffer + '"]').trigger('click')
        open_buffer = false
      }
    })
    return false
  })
})

window.refreshTimeline = function() {
  ScrollTrigger.refresh(true)
}
